import React from 'react';
import PropTypes from 'prop-types';
import {genericMandarkRequest} from 'resources/mandark.resource';
import {resource} from '@albert-io/json-api-framework/request/builder';

import Text from '@albert-io/atomic/atoms/Text/Text.react';

import Heading from '@albert-io/atomic/atoms/Heading/Heading.react';

import notifier from '@albert-io/notifier';

import CoppaMessage from './CoppaMessage';

import CoppaError from './CoppaError';
import HandleCoppa from './HandleCoppa.react';

export default class CoppaApprove extends React.Component {
  static propTypes = {
    verificationCode: PropTypes.string.isRequired,
    consentId: PropTypes.string.isRequired
  };

  onError = (e) => {
    notifier.notify(e, {
      message: 'Failed to approve COPPA consent',
      tags: 'CoppaConfirm',
      context: {
        verificationCode: this.props.verificationCode,
        consentId: this.props.consentId
      }
    });
  };

  render() {
    const query = () =>
      genericMandarkRequest(
        'patch',
        resource('coppa_consent_grant_v1')
          .mandarkEndpoint(['coppa_consent_grants_v1', this.props.consentId, 'approve_coppa'])
          .customQuery({
            verification_code: this.props.verificationCode
          })
          .done()
      );

    const successComponent = (
      <CoppaMessage>
        <Heading>Success</Heading>
        <Text paragraph as='p'>
          You have successfully granted your child permission to use Albert!
        </Text>
        <Text paragraph as='p'>
          You may close this page.
        </Text>
      </CoppaMessage>
    );

    const errorComponent = <CoppaError />;

    return (
      <HandleCoppa
        query={query}
        successComponent={successComponent}
        errorComponent={errorComponent}
        onError={this.onError}
      />
    );
  }
}
